import Breadcrumb from './src/breadcrumb';

Breadcrumb.install = function(Vue) {
  Vue.component(Breadcrumb.name, Breadcrumb);
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.js